import { Button } from "@/components/ui/button";

export default function PageHeader({ title, description, action, actionLabel, actionIcon: Icon, testId }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-8">
      <div className="space-y-1.5">
        <h2 className="font-display text-2xl sm:text-3xl font-bold tracking-tight" data-testid={`${testId}-title`}>
          {title}
        </h2>
        {description && (
          <p className="text-sm text-muted-foreground max-w-2xl leading-relaxed">
            {description}
          </p>
        )}
      </div>
      {action && (
        <Button onClick={action} data-testid={`${testId}-action`} className="shrink-0">
          {Icon && <Icon className="mr-2 h-4 w-4" strokeWidth={1.5} />}
          {actionLabel}
        </Button>
      )}
    </div>
  );
}
